import { Organization } from '../../api';
import { StatusBadge } from '../ui';

interface OrganizationTabProps {
  organization: Organization;
}

export function OrganizationTab({ organization }: OrganizationTabProps) {
  const isSSO = organization.auth_method === 'sso';

  return (
    <div className="tab-content">
      <div className="org-info-section">
        <h3>Organization Details</h3>
        <div className="info-grid">
          <div className="info-row">
            <span className="info-label">Name</span>
            <span className="info-value">{organization.name}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Status</span>
            <span className="info-value">
              <StatusBadge status={organization.status} />
            </span>
          </div>
          <div className="info-row">
            <span className="info-label">Created</span>
            <span className="info-value">
              {new Date(organization.created_at).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>

      <div className="org-info-section">
        <h3>Authentication</h3>
        <div className="info-grid">
          <div className="info-row">
            <span className="info-label">Method</span>
            <span className="info-value">
              <span className={`auth-badge ${isSSO ? 'sso' : 'password'}`}>
                {isSSO ? 'Single Sign-On (SSO)' : 'Password'}
              </span>
            </span>
          </div>
        </div>

        {isSSO && (
          <div className="info-note">
            SSO is configured for your organization. To modify SSO settings or
            update your identity provider configuration, please contact Fakto support.
          </div>
        )}

        {!isSSO && (
          <div className="info-note">
            Your organization uses password-based authentication. Users can be
            invited via email and will set their own passwords.
          </div>
        )}
      </div>
    </div>
  );
}
